app.helpers = {
	// COMMON --------------------------------------------
	// Configs + Constants
	TIMERS: '',
	DATA: '',
	AJAX: '',


	// MAIN FUNCTIONS ------------------------------------
	init: function(){
		var _this = app.helpers;

		_this.setupEvents();
		_this.setupLayout();
	},

	setupEvents: function() {},
	setupLayout: function() {},



	// OTHER FUNCTIONS -----------------------------------
	browserDetect: function(){
		var ua = window.navigator.userAgent;

		var msie = ua.indexOf('MSIE ');
		if (msie > 0) {
			// IE 10 or older => return version number
			return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
		}

		var trident = ua.indexOf('Trident/');
		if (trident > 0) {
			// IE 11 => return version number
			var rv = ua.indexOf('rv:');
			return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
		}

		var edge = ua.indexOf('Edge/');
		if (edge > 0) {
			// Edge (IE 12+) => return version number
			return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
		}

		// other browser
		return false;
	},

	osDetect: function(){
		var res = false;
		if (navigator.appVersion.indexOf("Win")!==-1){res="Windows";}
		else if (navigator.appVersion.indexOf("Mac")!==-1){res="MacOS";}
		else if (navigator.appVersion.indexOf("X11")!==-1){res="UNIX";}
		else if (navigator.appVersion.indexOf("Linux")!==-1){res="Linux";}

		return res;
	},

	getUrlParam: function(name, url) {
		if (!url) url = window.location.href;
		name = name.replace(/[\[\]]/g, "\\$&");
		var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
			results = regex.exec(url);
		if (!results) return null;
		if (!results[2]) return '';
		return decodeURIComponent(results[2].replace(/\+/g, " "));
	},

	getRandom: function(min, max, type){
		if(type === 'int'){
			min = Math.ceil(min);
			max = Math.floor(max);

			return Math.floor(Math.random() * (max - min + 1)) + min;
		}
		else{
			return Math.random() * (max - min) + min;
		}
	},

	//Verifica se existe e se não está vazio
	isEmpty: function (param) {
		return !(param !== undefined && param !== null && param !== '');
	},

	//Verifica se é elemento e se exite
	isElement: function (obj) {
		return (obj !== undefined && obj !== null && obj !== '' && (obj.length > 0 || $(obj).length > 0 ));
	},

	isInArray: function (value, array) {
		return array.indexOf(value) > -1;
	},

	compareArrays: function(a, b) {
		var i = a.length;
		if (i !== b.length) return false;
		while (i--) {
			if (a[i] !== b[i]) return false;
		}
		return true;
	},

	//Gera um tipo de Unique ID (não é válido p/ BD's)
	uid: function () {
		function s4() {
			return Math.floor((1 + Math.random()) * 0x10000)
				.toString(16)
				.substring(1);
		}

		return s4() + s4();
	},

	//ROUND
	round: function (num, decimals) {
		return Math.round(num * Math.pow(10, decimals)) / Math.pow(10, decimals);
	},

	easingFn: function (t, b, c, d) {
		var ts = (t /= d) * t;
		var tc = ts * t;
		return b + c * (tc + -3 * ts + 3 * t);
	},

	hasNumber: function(string){
		return /\d/.test(string);
	}
};
